'use strict';

import { find } from 'lodash';

var externalEcommerceController = function ($controller, $window, workflowService) {

    var vm = this;
    angular.extend(vm, $controller('baseStepController'));

    vm.$onInit = function () {
        vm.initializeStep(vm.$stateParams).then(function (executionStep) {
            vm.executionStep = executionStep;

            // Get required parameters from ticket step
            var baseUrl = getParameterValue(executionStep.ticketStep.parameters, 'externalBaseUrl');
            var cellName = getParameterValue(executionStep.ticketStep.parameters, 'externalCellIdentifier');

            // Get ticket information
            var ticketId = executionStep.ticketStep.ticketId;

            // Construct passback URL - the external system will redirect back here
            var protocol = $window.location.protocol;
            var host = $window.location.host;
            var passbackUrl = protocol + '//' + host + '/#/externalEcommercePassback?ticketId=' + ticketId + '&ticketStepId=' + executionStep.ticketStep.id;

            // Construct the URL in the format:
            // https://incx-es-pilotwgmg-usa-1.shopperfacts.com/[cell_name]/?r=[user_unique_id]&passbackUrl=[encoded_url]

            // Remove trailing slash from base URL if present
            if (baseUrl.endsWith('/')) {
                baseUrl = baseUrl.slice(0, -1);
            }

            var url = baseUrl + '/' + encodeURIComponent(cellName) +
                '?r=' + ticketId +
                '&link=' + encodeURIComponent(passbackUrl);

            console.log('Redirecting to external ecommerce system:', url);

            // Redirect to external system without completing the step
            // The step will be completed by the passback controller
            vm.redirect(url);
        });
    };

    function getParameterValue(parameters, parameterName) {
        var param = find(parameters, function (p) {
            return p.argumentName === parameterName;
        });

        return param ? param.value : null;
    }

    vm.redirect = function (url) {
        $window.onbeforeunload = null;
        $window.location.href = url;
    };
};

externalEcommerceController.$inject = ['$controller', '$window', 'workflowService'];

export var externalEcommerceComponent = {
    name: 'externalEcommerce',
    controller: externalEcommerceController,
    bindings: {
        $stateParams: '<'
    }
};

export var externalEcommerceRoute = {
    name: 'externalEcommerce',
    url: '/externalEcommerce',
    component: 'externalEcommerce'
};
